import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router, { trackRouteLoad } from './router/index'
import Notifications from 'vue-notification'
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import appConfig from "@/app.config";
import { applyBrand } from "@/helpers/brand";
import { syncSupportChat } from "@/helpers/support-chat";

import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

import "../src/design/app.scss";

import store from '@/state/store'

import App from './App.vue'

import i18n from './i18n'


Vue.use(VueRouter)
Vue.use(vco)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(Notifications)
// enforceFocus apagado: cada overlay activo le roba el foco al otro en un
// `focusin` del documento, así que con dos loaders a la vez (p. ej. las pestañas
// de Configuraciones) entran en recursión infinita y la pestaña se cuelga.
Vue.use(VueLoading,{
  color: '#5e40bf',
  enforceFocus: false
})

// <apexchart> (apexcharts, ~135 KB gz) ya no viaja en el bundle inicial: se baja
// en paralelo con la primera pantalla que no sea de cuenta (login, registro…)
// y la navegación espera a que esté registrado antes de mostrarla. Así el
// componente sigue siendo síncrono para las vistas: los `this.$refs.chart
// .updateSeries(...)` de mounted() encuentran el chart como antes.
let chartsReady = null
function loadCharts() {
  if (!chartsReady) {
    chartsReady = import('vue-apexcharts').then(module => {
      Vue.component('apexchart', module.default || module)
    })
    // Si falla (chunk de un deploy viejo), el próximo intento lo vuelve a pedir.
    chartsReady.catch(() => { chartsReady = null })
  }
  return chartsReady
}
const chartlessPaths = ['/login', '/register', '/forgot-password', '/accept-invite', '/select-company', '/404']
const needsCharts = route => !chartlessPaths.includes(route.path)
router.beforeEach((routeTo, routeFrom, next) => {
  if (needsCharts(routeTo)) loadCharts().catch(() => {})
  next()
})
router.beforeResolve((routeTo, routeFrom, next) => {
  if (!needsCharts(routeTo)) return next()
  // Un error acá llega a router.onError (recuperación de chunks).
  trackRouteLoad(loadCharts()).then(() => next(), next)
})

if(window.config.env && (window.config.env=='pd' || window.config.env=='stg')){
  Sentry.init({
    Vue,
    dsn: "https://16bcb01133614578a5001cb885ad2e39@glitchtip.goshops.com/13",
    integrations: [
      new BrowserTracing(),
    ],
    tracesSampleRate: 0.25,
    environment: window.config.env,
    release: "go-shops@" + appConfig.version
  });
}

// White-label: neutraliza favicon/manifest/título iOS que el build inyecta con
// la marca gopersonal. No-op en admin.gopersonal.ai. Ver src/helpers/brand.js.
applyBrand()

// Chat de soporte: vive fuera de #app para sobrevivir a los cambios de ruta, y
// solo aparece con sesión completa (logueado + proyecto elegido). Lo sincronizamos
// en cada navegación porque login, logout y el cambio de compañía o de proyecto
// pasan siempre por el router; la navegación inicial también dispara el hook.
router.afterEach((to) => {
  // El nombre de la ruta viaja al chat: con eso sugiere cosas que tengan
  // sentido en esta pantalla (ver setSupportChatScreen).
  syncSupportChat({ label: i18n.t('common.support_chat'), screen: to && to.name })
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
